import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { StarmsClientProvider } from "../starms-client/starms-client";
import { BehaviorSubject } from "rxjs";
import { Storage } from "@ionic/storage";
import {
  BannerMessageAdapter,
  BannerMessage,
} from "../../app/models/BannerMessage";
import { AlertController } from "ionic-angular";
import "rxjs/add/operator/map";

const STORAGE_KEY = "dontShowBanners";

@Injectable()
export class BannersProvider {
  private base = "https://sta-rms.siemens-energy.com";

  loginMessages = new BehaviorSubject<BannerMessage[]>([]);
  inAppMessages = new BehaviorSubject<BannerMessage[]>([]);

  constructor(
    private starms: StarmsClientProvider,
    private storage: Storage,
    private http: HttpClient,
    private alertCtrl: AlertController
  ) {}

  fetchMessages() {
    this.http
      .get(this.base + "/myhealth/assets/demo-data/inform.json")
      .map((rawData: { messages: any[] }) =>
        rawData.messages.map((entry) => new BannerMessageAdapter().adapt(entry))
      )
      .subscribe((messages) => {
        this.storage.get(STORAGE_KEY).then((dontShowBanners: number[]) => {
          if (dontShowBanners !== null) {
            this.loginMessages.next(
              messages.filter(
                (entry) =>
                  entry.visibility_mobile_splash &&
                  dontShowBanners.findIndex((x) => x === entry.id) === -1
              )
            );
            this.inAppMessages.next(
              messages.filter(
                (entry) =>
                  entry.visibility_mobile_inside &&
                  dontShowBanners.findIndex((x) => x === entry.id) === -1
              )
            );
          } else {
            this.loginMessages.next(
              messages.filter((entry) => entry.visibility_mobile_splash)
            );
            this.inAppMessages.next(
              messages.filter((entry) => entry.visibility_mobile_inside)
            );
          }
        });
        // this.loginMessages.next(messages.filter(entry => entry.visibility_mobile_splash));
      });
  }

  dontShowAgain(id: number) {
    this.storage.get(STORAGE_KEY).then((storedMessages) => {
      if (storedMessages === null) {
        this.storage
          .set(STORAGE_KEY, [id])
          .then()
          .catch((error) => {
            console.log("BANNERS: Error while saving visited banners", error);
          });
      } else {
        console.log(
          "BANNERS: ",
          STORAGE_KEY,
          " current value is ",
          storedMessages
        );
        storedMessages.push(id);
        this.storage.set(STORAGE_KEY, storedMessages);
      }
    });
  }

  async displayBannerMessage(message: BannerMessage) {
    // const alert = this.alertCtrl.create({
    //   title: message.title,
    //   message: message.message,
    //   buttons: [
    //     {
    //       text: "Do not show again",
    //       role: "cancel",
    //       handler: () => {
    //         // this.visibilities[element.id] = false;
    //         // localStorage.setItem('visibilities', JSON.stringify(this.visibilities));
    //         this.dontShowAgain(message.id);
    //       },
    //     },
    //     {
    //       text: "Dismiss",
    //       role: "dismiss",
    //       handler: () => {},
    //     },
    //   ],
    // });
    // await alert.present();
  }
}



// WEBPACK FOOTER //
// ./src/providers/banners/banners.ts